export default __webpack_public_path__ + "static/media/funky-tee.70c6de6d.jpg";